const TxLink = () => (
    <svg
        width='15'
        height='16'
        viewBox='0 0 15 16'
        fill='none'
        xmlns='http://www.w3.org/2000/svg'
    >
        <path
            d='M1.66667 15.5C1.20833 15.5 0.815833 15.3369 0.489167 15.0108C0.163055 14.6842 0 14.2917 0 13.8333V2.16667C0 1.70833 0.163055 1.31583 0.489167 0.989167C0.815833 0.663055 1.20833 0.5 1.66667 0.5H7.5V2.16667H1.66667V13.8333H13.3333V8H15V13.8333C15 14.2917 14.8369 14.6842 14.5108 15.0108C14.1842 15.3369 13.7917 15.5 13.3333 15.5H1.66667ZM5.58333 11.0833L4.41667 9.91667L12.1667 2.16667H9.16667V0.5H15V6.33333H13.3333V3.33333L5.58333 11.0833Z'
            fill='#9D9D9D'
        />
    </svg>
);

export default TxLink;
